import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Upload, Trash2 } from 'lucide-react';
import api from '../../api/axios';
import SuperadminLayout from '../../components/SuperadminLayout';
import ImportV2 from './ImportV2';
import ClearTenantData from './ClearTenantData';

// Superadmin → İdxal / İxrac v2: köhnə proqramın bazasından köçürmə (Import) və test importundan sonra boşaltma (Təmizlə).
// Import rejimi gizlədilir, unmount edilmir ki, seçilmiş fayl və uyğunlaşdırma itməsin.
export default function ImportV2Page() {
    const [tenants, setTenants] = useState([]);
    const [mode, setMode] = useState('import');

    useEffect(() => {
        api.get('/superadmin/tenants')
            .then(r => setTenants(r.data.data || []))
            .catch(() => toast.error('Restoranlar yüklənmədi.'));
    }, []);

    return (
        <SuperadminLayout
            title="İdxal / İxrac v2"
            subtitle="Köhnə proqramın bazasını (SQLite .db, SQL .sql) FiscalPOS-a köçür"
            actions={
                <div className="inline-flex rounded-xl border border-slate-200 bg-white p-1">
                    {[['import', 'Import', Upload], ['clear', 'Təmizlə', Trash2]].map(([k, l, Ic]) => (
                        <button key={k} type="button" onClick={() => setMode(k)}
                            className={`inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors ${
                                mode === k ? (k === 'clear' ? 'bg-red-600 text-white' : 'bg-slate-900 text-white') : 'text-slate-500 hover:bg-slate-50'
                            }`}>
                            <Ic className="h-3.5 w-3.5" />{l}
                        </button>
                    ))}
                </div>
            }
        >
            <div className={mode === 'import' ? '' : 'hidden'}>
                <ImportV2 tenants={tenants} />
            </div>
            {mode === 'clear' && <ClearTenantData tenants={tenants} />}
        </SuperadminLayout>
    );
}
